const notes = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
export default notes;



/** WEBPACK FOOTER **
 ** ./src/constants/NOTES.js
 **/